import React from 'react';
import { Tag } from 'primereact/tag';
import type { AlcanceAsignadoVista } from '../types/metas.types';

/**
 * Piezas de un ACCESO a metas (quién es supervisor o regional de quién) que
 * comparten la pestaña «Accesos», la sección de metas en Usuarios y el
 * encabezado de la pantalla («Tu alcance: Supervisor de …»).
 */

/** Cómo se nombra el alcance de dirección (21-oct-2026): su nombre guardado («TODAS») no dice nada. */
export const ETIQUETA_DIRECCION = 'Dirección (todas las tiendas, sólo lectura)';

/** «Supervisor de ESTHER MORALES» / «Regional de Arturo Barrios» / «Dirección (todas las tiendas, sólo lectura)». */
export const etiquetaAlcance = (a: { tipo: string; nombre: string }) =>
  a.tipo === 'direccion' ? ETIQUETA_DIRECCION : `${a.tipo === 'regional' ? 'Regional' : 'Supervisor'} de ${a.nombre}`;

/**
 * Etiquetas rojas de un acceso que ya no da acceso a nada.
 *
 * ⚠️ Los nombres del catálogo son LLAVES DE ACCESO: renombrar a un supervisor
 * en el catálogo deja a su cuenta sin tiendas. Por eso se ve.
 */
export const AlertasAlcance: React.FC<{ a: AlcanceAsignadoVista }> = ({ a }) => (
  <span className="inline-flex flex-wrap gap-1">
    {a.cuentaEliminada && <Tag value="Cuenta eliminada" severity="danger" />}
    {!a.nombreEnCatalogo && (
      <Tag
        value="No existe en el catálogo"
        severity="danger"
        title="Ese nombre ya no está en el catálogo de tiendas: la cuenta no ve ninguna tienda con este alcance."
      />
    )}
  </span>
);
